<script>
import sessionStore from '@/session/sessionStore'

export default {
    name: 'DiagnosisCaseMixin',
    props: {
        caseData: Object,
        consultations: { type: Array, default: () => [] }
    },
    computed: {
        caseId() {
            return this.caseData?.casId
        },
        caseNumber() {
            return this.caseData?.casenumber
        },

        isPathologist() {
            return this.caseData?.pathologist?.id === sessionStore.getUserPersonnelId()
        },
        visibleConsultations() {
            return this.isPathologist || !!this.consultations.length
        }
    }
}
</script>
